<template>
  <div id="courseContent">
    <v-toolbar
      class="ml-0 pl-3 elevation-0"
      :color="$vuetify.theme.dark ? '#121212' : '#ffffff'"
    >
      <v-toolbar-title
        class="ml-0 pl-3"
        style="cursor: pointer"
        @click="goToCoursePage()"
      >
        <span>{{ this.course.course }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-layout
      fill-height
      :style="
        $vuetify.theme.dark
          ? 'background-color: #121212'
          : 'background-color: #ffffff'
      "
    >
      <v-card flat>
        <vue-perfect-scrollbar class="drawer-content--scroll">
          <v-list :color="$vuetify.theme.dark ? '#121212' : '#ffffff'">
            <v-list-group
              v-for="(section, index) in sections"
              :key="section.id"
              no-action
            >
              <template v-slot:activator>
                <div
                  style="
                    display: flex;
                    align-items: flex-start !important;
                    width: 100%;
                  "
                >
                  <v-icon class="pa-2 pt-4 pl-0" color="primary">
                    video_library
                  </v-icon>
                  <v-list-item-content>
                    <v-list-item-title style="white-space: initial">
                      {{ section.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </div>
              </template>
              <template v-for="(item, index2) in section.items.data">
                <v-list-item
                  small
                  :disabled="
                    !item.is_published || isNotAvailableOffline(item.id)
                  "
                  :key="item.id"
                  class="list-item pl-12"
                  @click="itemClick(item)"
                >
                  <v-icon :color="item.log ? 'green' : 'grey lighten-1'" small>
                    {{ item.log ? "task_alt" : "radio_button_unchecked" }}
                  </v-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      style="white-space: break-spaces; font-size: 0.9rem"
                      v-html="item.learnable.lesson || item.description"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      class="v-size--x-small"
                      dense
                      v-html="item.learnable.description"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </v-list>
        </vue-perfect-scrollbar>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import CourseService from "../../services/courses.service";

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    courseId: {
      required: true,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      course: {},
      sections: {},
      isOffline: !navigator.onLine,
    };
  },
  mounted() {
    this.loadCourse(this.$props.courseId);
    window.addEventListener("offline", () => {
      this.isOffline = true;
    });
    window.addEventListener("online", () => {
      this.isOffline = false;
    });
  },
  methods: {
    isNotAvailableOffline(ItemId) {
      const hasOfflineSupport =
        localStorage.getItem("hasOfflineSupport_" + ItemId) === "1";
      return this.isOffline && !hasOfflineSupport;
    },
    clicked() {
      this.$emit("onClick");
    },
    loadCourse(courseId) {
      CourseService.getCourseById(courseId).then((response) => {
        this.course = response.data;
        console.log("loading course: ", this.course);
      });
      CourseService.getSectionsByCourseId(courseId).then((response) => {
        this.sections = response.data;
      });
    },
    goToCoursePage() {
      this.$router.push({ path: `/courses/${this.course.id}` });
    },
    itemClick(item) {
      console.log(item);
      item.log = {};
      this.$router.push({
        name: "classroom",
        params: {
          courseId: this.course.id,
          sectionItemId: item.id,
          slug: item.learnable.slug,
        },
      });
      this.$emit("classChanged");
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
#courseContent {
  overflow: hidden;

  .drawer-content--scroll {
    height: calc(100vh - 64px);
    width: 100%;
    overflow: auto;
  }
}
</style>
